import { stream } from 'fetch-event-stream';
import { getAuthToken } from 'api/AuthApi';

export function streamEvents(url, body) {
    const token = getAuthToken();

    return stream(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(body),
    });
}
